import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n'], ['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n']);

import React from 'react';
import styled from 'styled-components';

var StyledMonogramErrorMessage = styled.p(_templateObject, function (props) {
  return props.theme.dormifyRed;
});

var _ref = React.createElement(
  StyledMonogramErrorMessage,
  null,
  'Whoops! You must enter text to add this item to your cart'
);

var MonogramErrorMessage = function MonogramErrorMessage() {
  return _ref;
};

export default MonogramErrorMessage;